import type React from 'react';
import { useCallback } from 'react';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';
import './Vision.css';

export default function Vision(): React.JSX.Element {
  const onIntersect = useCallback((entry: IntersectionObserverEntry) => {
    entry.target.classList.add('vision--visible');
  }, []);

  const sectionRef = useIntersectionObserver<HTMLElement>(onIntersect);

  return (
    <section className="vision" ref={sectionRef} aria-labelledby="vision-eyebrow">
      <p id="vision-eyebrow" className="vision__eyebrow">Our Vision</p>
      <p className="vision__body">
        To build Australia's leading network of Hybrid Energy Hubs — self-sufficient rural campuses
        where renewable generation, grid-scale storage, and digital infrastructure converge on a
        single strategically held site, owned and operated as an integrated whole.
      </p>
    </section>
  );
}
